import { render, staticRenderFns } from "./ContentPageListScreen.vue?vue&type=template&id=32df809c&"
import script from "./ContentPageListScreen.vue?vue&type=script&lang=ts&"
export * from "./ContentPageListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports